import * as React from 'react';

import { StyledHeaderLink } from './StyledHeaderLink';

export type VALID_HEADER_LINKS = 'default' | 'dropdown';

interface IHeaderLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  hideOnDesktop?: boolean;
  hideOnMobile?: boolean;
  variant?: VALID_HEADER_LINKS;
  asListItem?: boolean;
  current?: boolean;
  forwardedAs?: 'button';
}

export const HeaderLink: React.FC<IHeaderLinkProps> = ({
  children,
  current,
  hideOnDesktop = false,
  hideOnMobile = false,
  asListItem = true,
  variant = 'default',
  forwardedAs,
  ...anchorProps
}) => {
  const ListItemWrap = asListItem ? 'li' : React.Fragment;

  return (
    <ListItemWrap>
      <StyledHeaderLink
        hideOnMobile={hideOnMobile && hideOnMobile}
        hideOnDesktop={hideOnDesktop && hideOnDesktop}
        variant={variant}
        current={current}
        aria-current={current}
        // tslint:disable-next-line:no-any
        as={forwardedAs ? ('button' as keyof JSX.IntrinsicElements | React.ComponentType<any>) : undefined}
        {...anchorProps}
      >
        {children}
      </StyledHeaderLink>
    </ListItemWrap>
  );
};

export default HeaderLink;
